// Pure packages compile without the DOM lib, so declare the two timer globals we use.
// They exist on every target (browsers, Workers, Bun, Node, React Native).
declare function setTimeout(fn: () => void, ms: number): unknown;
declare function clearTimeout(handle: unknown): void;

/** Injectable timers so scheduling can be tested without real waits. */
export interface Timers {
  setTimeout(fn: () => void, ms: number): unknown;
  clearTimeout(handle: unknown): void;
}

export const defaultTimers: Timers = {
  setTimeout: (fn, ms) => setTimeout(fn, ms),
  clearTimeout: (handle) => clearTimeout(handle),
};
